import { INavItem } from '../../../layout/navigation/models/nav-item.model';
import { InjectionToken } from '@angular/core';
import { INSIGHTS_NAVIGATION_CONFIG } from './insights-navigation.config';
import { ADMIN_NAVIGATION_CONFIG } from './admin-navigation.config';
import { ROOT_ROUTES } from '../router.config';
import { AI_ASSISTANT_NAVIGATION_CONFIG } from './ai-assistant-navigation.config';

export const NAVIGATION_TOKEN = new InjectionToken<INavItem[]>('navigation items for the application', {
  factory: (): INavItem[] => NAV_ITEMS,
});

export const NAV_ITEMS: INavItem[] = [
  {
    label: ENavItemsLabels.dashboard,
    url: ROOT_ROUTES.dashboard,
    activeIcon: 'assets/icons/dashboard-icon-active.svg',
    inactiveIcon: 'assets/icons/dashboard-icon-inactive.svg',
    subNav: {
      title: ENavItemsLabels.dashboard,
      items: [],
    },
    buttons: [
      {
        label: 'Create Custom Dashboard',
        url: ROOT_ROUTES.newItem,
      },
    ],
  },
  {
    label: ENavItemsLabels.reporting,
    url: ROOT_ROUTES.reporting,
    activeIcon: 'assets/icons/reporting-icon-active.svg',
    inactiveIcon: 'assets/icons/reporting-icon-inactive.svg',
    subNav: {
      title: ENavItemsLabels.reporting,
      items: [],
    },
    buttons: [
      {
        label: 'Create Custom Report',
        url: ROOT_ROUTES.newItem,
      },
    ],
  },
  {
    label: ENavItemsLabels.aceInsights,
    url: ROOT_ROUTES.aceInsights,
    activeIcon: 'assets/icons/insights-icon-active.svg',
    inactiveIcon: 'assets/icons/insights-icon-inactive.svg',
    subNav: {
      title: ENavItemsLabels.aceInsights,
      items: INSIGHTS_NAVIGATION_CONFIG,
    },
    buttons: [],
  },
  {
    label: ENavItemsLabels.aiAssistant,
    url: ROOT_ROUTES.aiAssistant,
    activeIcon: 'assets/icons/ai-assistant-active.svg',
    inactiveIcon: 'assets/icons/ai-assistant-inactive.svg',
    subNav: {
      title: ENavItemsLabels.aiAssistant,
      items: AI_ASSISTANT_NAVIGATION_CONFIG,
    },
    buttons: [],
  },
  {
    label: ENavItemsLabels.calendar,
    url: ROOT_ROUTES.calendar,
    activeIcon: 'assets/icons/calendar-icon-active.svg',
    inactiveIcon: 'assets/icons/calendar-icon-inactive.svg',
    subNav: {},
    buttons: [],
    standalone: true,
  },
  {
    label: ENavItemsLabels.admin,
    url: ROOT_ROUTES.admin,
    activeIcon: 'assets/icons/admin-icon-active.svg',
    inactiveIcon: 'assets/icons/admin-icon-inactive.svg',
    subNav: {
      title: ENavItemsLabels.admin,
      items: ADMIN_NAVIGATION_CONFIG,
    },
    buttons: [],
  },
  {
    label: ENavItemsLabels.support,
    url: 'https://support.leasehawk.com/',
    activeIcon: 'assets/icons/support-icon.svg',
    inactiveIcon: 'assets/icons/support-icon.svg',
    subNav: {},
    buttons: [],
    standalone: true,
  },
];

export const enum ENavItemsLabels {
  dashboard = 'Dashboards',
  reporting = 'Reporting',
  admin = 'Admin',
  calendar = 'Calendar',
  support = 'Support',
  aceInsights = 'Insights',
  aiAssistant = 'AI Assistant',
}
